<template>
  <div>
      <el-form size="small" :model="rule" label-position="left">
        <el-form-item label="Title" :label-width="formLabelWidth">
          <el-input v-model="rule.title" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="Event" :label-width="formLabelWidth">
          <el-select @change="handleChange" style="width: 100%" v-model="rule.events" placeholder="Please select an event">
            <el-option 
              v-for="(ruleEvent, key) in ruleFields.events" 
              :key="key" 
              :label="ruleEvent.title" 
              :value="key">
            </el-option>
          </el-select>
        </el-form-item>

        <rule-action
          v-for="(action, key) in rule.actions" 
          :key="key"
          :actionKey="rule.events.actions" 
          :action="action" 
          :eventActions="ruleFields.events[rule.events].actions"
          :fields="ruleFields.actions">
        </rule-action>
      </el-form>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import RuleAction from '@/components/rules/RuleAction';

export default {
  name: 'RuleCreate',
  components: { RuleAction },
  data: () => ({
    formLabelWidth: '120px',
  }),
  computed: {
    ...mapState('rules', ['ruleFields']),
    fields() {
      if (!this.rule.events) return null;
      const fields = [];
      const eventActions = this.ruleFields.events[this.rule.events].actions;
      eventActions.forEach(field => {
        if (field in this.ruleFields.actions) {
          fields.push(this.ruleFields.actions[field]);
        }
      });
      return fields;
    },
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    campaign: {
      type: String,
      required: true,
    },
    rule: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleChange() {
      this.rule.actions = [];
    },
  },
  mounted() {
    this.$store.dispatch('rules/getRuleFields');
  },
};
</script>


// WEBPACK FOOTER //
// Rule.vue?6bbbfc43